import React from 'react';
import Loader from '../../components/loader';
import styles from './loader-box.scss';

const LoaderBox = () =>
  <div className={styles.container} data-hook="loader-box">
    <Loader/>
  </div>;

export default LoaderBox;



// WEBPACK FOOTER //
// ./app/components/loader-box/loader-box.js